import { useState } from "react";

import { NavLink } from "react-router-dom";

import { ReactComponent as Activity } from "../../../svgs/archive-tick.svg";
import { ReactComponent as Profile } from "../../../svgs/profile-tick.svg";
import { ReactComponent as LogoutIcon } from "../../../svgs/logout.svg";
import { ReactComponent as Transcript } from "../../../svgs/transcript.svg";
import { ReactComponent as Payment } from "../../../svgs/payment.svg";

import styles from "./sidebar.module.scss";
import CustomModal from "../../../customs/modal/modal";
import Logout from "../../logout/main";

const Sidebar = ({ closeSidebar }: { closeSidebar: () => void }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  return (
    <main className={styles.nav}>
      <div className={styles.logoWrapper}></div>
      <div className={styles.menuHeader}>Menu</div>

      <div className={styles.sidebarItems}>
        <NavLink
          className={({ isActive }) =>
            `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`
          }
          to={"/activity-history"}
          onClick={closeSidebar}
        >
          {({ isActive }) => (
            <>
              <Activity className={isActive ? styles.activeIcon : ""} />
              <span>Activity</span>
            </>
          )}
        </NavLink>

        <NavLink
          className={({ isActive }) =>
            `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`
          }
          to={"/transcript"}
          onClick={closeSidebar}
        >
          {({ isActive }) => (
            <>
              <Transcript className={isActive ? styles.activeIcon : ""} />
              <span>Transcript</span>
            </>
          )}
        </NavLink>

        <NavLink
          className={({ isActive }) =>
            `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`
          }
          to={"/payment-history"}
          onClick={closeSidebar}
        >
          {({ isActive }) => (
            <>
              <Payment className={isActive ? styles.activeIcon : ""} />
              <span>Payment History</span>
            </>
          )}
        </NavLink>

        <NavLink
          className={({ isActive }) =>
            `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`
          }
          to={"/profile"}
          onClick={closeSidebar}
        >
          {({ isActive }) => (
            <>
              <Profile className={isActive ? styles.activeIcon : ""} />
              <span>Profile</span>
            </>
          )}
        </NavLink>

        <NavLink
          className={({ isActive }) =>
            `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`
          }
          to={"/clearance"}
          onClick={closeSidebar}
        >
          {({ isActive }) => (
            <>
              <Transcript className={isActive ? styles.activeIcon : ""} />
              <span>Clearance</span>
            </>
          )}
        </NavLink>
      </div>

      <hr className={styles.space} />

      <label className={styles.navLink} onClick={handleOpenModal}>
        <LogoutIcon /> <span>Logout</span>
      </label>

      <CustomModal
        title="Logout"
        maxWidth="xs"
        open={openModal}
        handleClose={handleCloseModal}
        content={<Logout handleClose={handleCloseModal} />}
      />
    </main>
  );
};

export default Sidebar;
